import { TextField } from '@mui/material';
import { useViewContractsState } from 'customer-management/customer-details/view-contracts/state/view-contracts-state';

export function DialogCommentField() {
  const state = useViewContractsState();
  return (
    <TextField
      label='Comments'
      fullWidth
      multiline
      rows={5}
      value={state.comments.get()}
      onChange={event => {
        state.comments.set(event.target.value);
      }}
    />
  );
}
